import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const updates = [
  {
    id: 1,
    title: "Tesla Q4 2024 Earnings Report",
    category: "Tesla",
    date: "Jan 29, 2025",
    excerpt: "Record-breaking quarterly earnings with unprecedented vehicle deliveries.",
  },
  {
    id: 2,
    title: "SpaceX Starship Flight 7 Success",
    category: "SpaceX",
    date: "Jan 25, 2025",
    excerpt: "Full integrated flight test achieves booster catch and new orbital maneuvers.",
  },
  {
    id: 3,
    title: "Neuralink Brain Implant Milestone",
    category: "Innovation",
    date: "Jan 20, 2025",
    excerpt: "Second patient successfully receives neural implant; exceeds performance targets.",
  },
  {
    id: 4,
    title: "Tesla Giga Berlin Expansion",
    category: "Tesla",
    date: "Jan 15, 2025",
    excerpt: "New production facility opens with latest battery technology on line.",
  },
  {
    id: 5,
    title: "The Boring Company Tunnel Network",
    category: "Future Tech",
    date: "Jan 10, 2025",
    excerpt: "Vegas Loop underground transport system enters phase 3 expansion.",
  },
  {
    id: 6,
    title: "Starlink Satellite Constellation Update",
    category: "SpaceX",
    date: "Jan 5, 2025",
    excerpt: "50,000 active satellites now providing global internet coverage.",
  },
];

export default function UpdatesFeed() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: [0.4, 0, 0.2, 1] },
    },
    hover: {
      y: -5,
      transition: { duration: 0.3 },
    },
  };
  return (
    <motion.div
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-100px" }}
    >
      {updates.map((update, idx) => (
        <motion.div
          key={update.id}
          variants={cardVariants}
          whileHover="hover"
          className="group border border-border hover:border-foreground transition-colors duration-300 p-6 cursor-pointer"
        >
          <div className="flex items-start justify-between mb-4">
            <span className="text-xs font-medium text-muted-foreground uppercase tracking-widest">
              {update.category}
            </span>
            <span className="text-xs text-muted-foreground">{update.date}</span>
          </div>
          <h3 className="text-base font-medium text-foreground mb-3 group-hover:opacity-70 transition-opacity">
            {update.title}
          </h3>
          <p className="text-sm text-muted-foreground mb-4 line-clamp-2">
            {update.excerpt}
          </p>
          <motion.div
            className="flex items-center text-xs font-medium text-foreground opacity-0 group-hover:opacity-100 transition-opacity"
            initial={{ x: 0 }}
            whileHover={{ x: 4 }}
          >
            Read More <ArrowRight className="ml-2 h-3 w-3" />
          </motion.div>
        </motion.div>
      ))}
    </motion.div>
  );
}